import { VBC_LOGO_DARK } from "constants/images";

const Footer = () => {
  return (
    <div className="bg-white py-5 text-dark text-sm app-dashboard-footer flex items-center justify-center">
      © Công ty Cổ phần Vietnam Blockchain 2024 <img src={VBC_LOGO_DARK} alt="" width={80} height={40} />
    </div>
  );
};

export default Footer;
